<template>
	<v-switch v-model="value" @update:model-value="onSwitchChange" density="compact" hide-details color="primary" />
</template>

<script setup>
import { ref, onMounted } from 'vue';

const props = defineProps({
	params: {
		type: Object,
		required: true,
	},
});

const value = ref(false);

onMounted(() => {
	value.value = props.params.value;
});

function onSwitchChange(newValue) {
	value.value = newValue;
	props.params.setValue(newValue);
}
</script>
